import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import styled from 'styled-components'

export function SectionDeposit() {
	return (
		<Section>
			<ViewRoot>
				<TextTitle>Что такое Инвестиции для бизнеса?</TextTitle>
				<ViewRow>
					<ViewItem>
						<ImageStyled name='what-is-deposit-1.png' alt='' />
						<Text>
							<strong>По принципу работы продукт похож на банковский вклад для бизнеса:</strong>{' '}
							процент дохода и срок зафиксированы в договоре. Выплаты ежемесячно. По окончании срока
							средства можно вывести или пролонгировать договор.
						</Text>
					</ViewItem>
					<ViewItem>
						<ImageStyled name='investProtected2.png' alt='' />
						<Text>
							<strong>Привлечённые средства направляются на покупку залоговых займов.</strong> ООО
							ПКО «КК.Консалт» управляет портфелем залоговых займов с обеспечением в виде ликвидной
							недвижимости.
						</Text>
					</ViewItem>
					<ViewItem last>
						<ImageStyled name='investProtected1.png' alt='' />
						<Text>
							ООО ПКО «КК.Консалт» работает <strong>исключительно с обеспеченными займами,</strong>{' '}
							что защищает ваши деньги. Кроме того АО «Кредит Клаб Групп» предоставляет
							поручительство на полную сумму ваших инвестиций.
						</Text>
					</ViewItem>
				</ViewRow>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(({ theme }) => ({
	marginBottom: 60,
	marginTop: 60,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 100,
		marginTop: 100,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
	},
}))

const ViewRow = styled.div(({ theme }) => ({
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'flex-start',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
}))

interface ViewItemProps {
	last?: boolean
}

const ViewItem = styled.div<ViewItemProps>(({ theme, last = false }) => ({
	flex: 1,
	maxWidth: 264,
	marginRight: 0,
	marginBottom: last ? 0 : 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 30,
		marginBottom: 0,
		justifyContent: 'space-between',
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	width: 264,
	marginBottom: 30,
	aspectRatio: '240/180',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 20,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))
